import React from "react";
import Masonry from "react-masonry-css";

import { MasonryContainerProps } from "./MasonryContainer.types";

import "./MasonryContainer.scss";

const MasonryContainer: React.FC<MasonryContainerProps> = ({ items }) => (
  <Masonry
    data-testid="MasonryContainer"
    className="mp-templates-masonrycontainer--main"
    columnClassName={"column"}
    breakpointCols={{
      default: 4,
      1400: 3,
      1000: 2,
      700: 1,
    }}
  >
    {items &&
      items.map((item, index) => {
        return (
          <div key={`masonry-item-${index}`} className="item">
            {item}
          </div>
        );
      })}
  </Masonry>
);

export default MasonryContainer;
